import { Box, Button, FormControl, Select, Snackbar, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { countrylist } from '../../services/countryList'
import { fnameVali, lnameVali, phVali, countryVali, addrVali, emailValidator } from '../../pages/user/validation'
import { Autocomplete } from '@mui/material';
import './hoteldetail.css'
import '../hotels/hotelsummary/hotelsummary.css'
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { birthDate, dateExp, issueCountry, passportNnum, panValidation } from '../flights/flight-booking/flight-summary/travellerValidation.js'
import { authPost } from '../../utility/apiConfig'
import { API_BASE_URL } from '../../utility/apiConstants'


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const titleoption = [
  {
    value: '1',
    label: 'Mr',
    gender: 1
  },
  {
    value: '2',
    label: 'Ms',
    gender: 2
  },
  {
    value: '5',
    label: 'Mrs',
    gender: 1
  },
  {
    value: '3',
    label: 'Miss',
    gender: 2
  },
  {
    value: '6',
    label: 'Mstr',
    gender: 1
  }
]

const titleOptChild = [
  {
    value: '3',
    label: 'Miss',
    gender: 2
  },
  {
    value: '6',
    label: 'Mstr',
    gender: 1
  }
]

const GuestDetails = (props) => {
  const history = useHistory()
  const [bookingErrMsg, setBookingErrMsg] = useState('')
  const [chStatus, setChStatus] = useState(false)
  const [open, setOpen] = React.useState(false);
  const [adult, setAdult] = useState([])
  const [child, setChild] = useState([])
  const [details, setDetails] = useState({
    billing_country: '',
    billing_city: 'test',
    billing_zipcode: 'test',
    // country_code: '+' + props.hotelBookingData.user_country_code || '',
    // cError: '',
    // passenger_contact: props.hotelBookingData.agent_mobile || '',
    // phError: '',
    // billing_email: props.hotelBookingData.agent_email || '',
    // emailError: '',
    // billing_address_1: props.hotelBookingData.agent_address || '',
    // addrError: '',
    // tc: 'on',
    // payment_method: ''
  })

  const sortPhoneNumber = (a, b) => {
    if ((a.country_code.length) < (b.country_code.length)) {
      return -1
    } else if ((a.country_code.length) > (b.country_code.length)) {
      return 1
    } else {
      return 0
    }
  }

  const validateBooking = (function () {
    return {
      adultVal: function () {
        const adlt = [...adult]
        adlt.map((v, i) => {
          const f = fnameVali(v.first_name)
          const l = lnameVali(v.last_name)
          if (f || l) {
            adlt[i].fError = f
            adlt[i].lError = l
            setAdult(adlt)
            // setAdStatus(false)
            return false
          } else {
            // setAdStatus(true)
          }
        })
      },

      childVal: function () {
        if (child) {
          const chld = [...child]
          chld.map((v, i) => {
            const f = fnameVali(v.first_name)
            const l = lnameVali(v.last_name)
            if (f || l) {
              chld[i].fError = f
              chld[i].lError = l
              setChild(chld)
              setChStatus(false)
              return false
            } else {
              //  setChStatus(true)
            }
          })
        } else {
          // setChStatus(true)
        }
      },

      detailVal: function () {
        const email = emailValidator(details.billing_email)
        const code = countryVali(details.country_code)
        const ph = phVali(details.passenger_contact)
        const addr = addrVali(details.billing_address_1)

        if (email || code || ph || addr) {
          setDetails({
            ...details,
            emailError: email,
            phError: ph,
            cError: code,
            addrError: addr
          })
          //  setDetStatus(false)
          return false
        } else {
          // setDetStatus(true)
          return true
        }
      }

    }
  })()

  function * generateSequence () {
    yield validateBooking.adultVal()
    yield validateBooking.childVal()
    yield validateBooking.detailVal()
  }

  const finalHotelBooking = () => {
    const adlt = [...adult]
    let ccc

    const email = emailValidator(details.billing_email)
    const code = countryVali(details.country_code)
    const ph = phVali(details.passenger_contact)
    const addr = addrVali(details.billing_address_1)

    const aaa = adlt.map((v, i) => {
      const f = fnameVali(v.first_name)
      const l = lnameVali(v.last_name)

      let dob = ''; let exp = ''; let ic = ''; let pasnnum = ''; let panval = ''

      // props.searchData.IsPassportMandatory
      if (props.bookingDatas.pre_booking_params.IsPassportMandatory) {
        dob = birthDate(v.date_of_birth)
        exp = dateExp(v.passport_expiry_date)
        ic = issueCountry(v.passenger_passport_issuing_country)
        pasnnum = passportNnum(v.passenger_passport_number)
      } else {
        dob = ''
        exp = ''
        ic = ''
        pasnnum = ''
      }

      // props.searchData.IsPANMandatory
      if (props.bookingDatas.pre_booking_params.IsPANMandatory) {
        panval = panValidation(v.pan_card)
      } else {
        panval = ''
      }

      if (f || l || dob || exp || ic || pasnnum || panval) {
        adlt[i].fError = f
        adlt[i].lError = l
        adlt[i].dobError = dob
        adlt[i].pdoeError = exp
        adlt[i].pCountryError = ic
        adlt[i].pnumbError = pasnnum
        adlt[i].panError = panval

        setAdult(adlt)
        return false
      }
    })
    if (child) {

      const chld = [...child]

      ccc = chld.map((v, i) => {
        const f = fnameVali(v.first_name)
        const l = lnameVali(v.last_name)

        let dob = ''; let exp = ''; let ic = ''; let pasnnum = ''; let panval = ''
        // props.searchData.IsPassportMandatory
        if (props.bookingDatas.pre_booking_params.IsPassportMandatory) {
          dob = birthDate(v.date_of_birth)
          exp = dateExp(v.passport_expiry_date)
          ic = issueCountry(v.passenger_passport_issuing_country)
          pasnnum = passportNnum(v.passenger_passport_number)
        } else {
          dob = ''
          exp = ''
          ic = ''
          pasnnum = ''
        }
        // props.searchData.IsPANMandatory
        if (props.bookingDatas.pre_booking_params.IsPANMandatory) {
          panval = panValidation(v.pan_card)
        } else {
          panval = ''
        }

        if (f || l || dob || exp || ic || pasnnum || panval) {
          chld[i].fError = f
          chld[i].lError = l
          chld[i].fError = f
          chld[i].lError = l
          chld[i].dobError = dob
          chld[i].pdoeError = exp
          chld[i].pCountryError = ic
          chld[i].pnumbError = pasnnum
          chld[i].panError = panval

          setChild(chld)
          return false
        }
      })
    } else {
      ccc = [undefined]
      // return undefined;
    }

    const detailValid = {

      checkThing: function () {
        if (email || code || ph || addr) {
          setDetails({
            ...details,
            emailError: email,
            phError: ph,
            cError: code,
            addrError: addr
          })
          return false
        } else { return undefined }
      }
    }

    const ddd = detailValid.checkThing.bind(detailValid)

    const checkingPreview = [...aaa, ...ccc, ddd()].filter(v => v === false)

    if (checkingPreview.length > 0) {

    } else {
      props.reviewHandle()
    }
  }

  const hotelBookingReq = () => {
    const obj = {
      token: props.bookingDatas.pre_booking_token,
      token_key: props.bookingDatas.pre_booking_token_key,
      op: 'book_flight',
      booking_source: props.bookingDatas.booking_source,
      passenger_type: [],
      lead_passenger: [],
      gender: [],
      name_title: [],
      first_name: [],
      middle_name: [],
      last_name: [],
      pan_card: [],
      date_of_birth: [],
      passenger_passport_number: [],
      passenger_passport_issuing_country: [],
      passenger_passport_expiry_day: [],
      passenger_passport_expiry_month: [],
      passenger_passport_expiry_year: [],
      billing_country: details.billing_country,
      billing_city: details.billing_city,
      billing_zipcode: details.billing_zipcode,
      country_code: details.country_code,
      passenger_contact: details.passenger_contact,
      billing_email: details.billing_email,
      billing_address_1: details.billing_address_1,
      tc: 'on',
      payment_method: props.bookingDatas.active_payment_options[0],
      passenger_nationality: []
    }

    adult.map((v, i) => {
      obj.passenger_type.push(v.passenger_type)
      obj.lead_passenger.push(v.lead_passenger)
      obj.gender.push(v.gender)
      obj.name_title.push(v.name_title)
      obj.first_name.push(v.first_name)
      obj.middle_name.push(v.middle_name)
      obj.last_name.push(v.last_name)
      obj.pan_card.push(v.pan_card)
      obj.date_of_birth.push(v.date_of_birth)
      obj.passenger_passport_number.push(v.passenger_passport_number)
      obj.passenger_passport_issuing_country.push(v.passenger_passport_issuing_country)
      obj.passenger_passport_expiry_day.push(v.passenger_passport_expiry_day)
      obj.passenger_passport_expiry_month.push(v.passenger_passport_expiry_month)
      obj.passenger_passport_expiry_year.push(v.passenger_passport_expiry_year)
      obj.passenger_nationality.push(v.passenger_nationality)
    })

    if (child) {
      child.map((v, i) => {
        obj.passenger_type.push(v.passenger_type)
        obj.lead_passenger.push(v.lead_passenger)
        obj.gender.push(v.gender)
        obj.name_title.push(v.name_title)
        obj.first_name.push(v.first_name)
        obj.middle_name.push(v.middle_name)
        obj.last_name.push(v.last_name)
        obj.pan_card.push(v.pan_card)
        obj.date_of_birth.push(v.date_of_birth)
        obj.passenger_passport_number.push(v.passenger_passport_number)
        obj.passenger_passport_issuing_country.push(v.passenger_passport_issuing_country)
        obj.passenger_passport_expiry_day.push(v.passenger_passport_expiry_day)
        obj.passenger_passport_expiry_month.push(v.passenger_passport_expiry_month)
        obj.passenger_passport_expiry_year.push(v.passenger_passport_expiry_year)
        obj.passenger_nationality.push(v.passenger_nationality)
      })
    }

    authPost(API_BASE_URL + 'hotel/pre_booking/' + props.bookingDatas.pre_booking_params.search_id, obj)
      .then((response) => {
        //  http://b2b.dev.com/voucher/hotel/HB2311202014461192/PTBSID0000000034/BOOKING_CONFIRMED/show_voucher

        if (response.data.status) {
          history.push('/voucher/hotel/' + response.data.data.book_id + '/' + response.data.data.booking_source + '/' + response.data.data.status + '/show_voucher')
        } else {
          if (response.data.message === null) {
            setBookingErrMsg('Something went wrong.')
          } else {
            // setBookingErrMsg(response.data.message)
            history.push({
              pathname: '/hotel/failed',
              state: response.data.message
            })
          }
        }
      })
      .catch((error) => {
      })
  }

  const handleCloseMsg = () => {
    setBookingErrMsg('')
  }


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {

    if (props?.searchData?.adult_config?.reduce((a, b) => a + b, 0) > 0) {
      const ad = [...adult];
      [...Array(Number(props?.searchData?.adult_config?.reduce((a, b) => a + b, 0)))].map((v, i) => {
        const obj = {
          passenger_type: '1',
          lead_passenger: '',
          gender: '1',
          name_title: '1',
          first_name: '',
          fError: '',
          middle_name: '',
          last_name: '',
          lError: '',
          passenger_passport_number: '',
          pnumbError: '',
          passenger_passport_issuing_country: '',
          countryValue: '',
          pCountryError: '',
          passenger_passport_expiry_day: '',
          passenger_passport_expiry_month: '',
          passenger_passport_expiry_year: '',
          date_of_birth: '',
          dobError: '',
          passport_expiry_date: '',
          pdoeError: '',
          pan_card: '',
          panError: '',
          passenger_nationality: '92'

        }
        ad[i] = obj
        setAdult(ad)
      })
    } else {
      setAdult(null)
    }

    if (props?.searchData?.child_config?.reduce((a, b) => a + b, 0) > 0) {
      const ch = [...child];
      [...Array(Number(props?.searchData?.child_config?.reduce((a, b) => a + b, 0)))].map((v, i) => {
        const obj = {
          passenger_type: '2',
          lead_passenger: '',
          gender: '2',
          name_title: '3',
          first_name: '',
          fError: '',
          middle_name: '',
          last_name: '',
          lError: '',
          passenger_passport_number: '',
          pnumbError: '',
          passenger_passport_issuing_country: '',
          countryValue: '',
          pCountryError: '',
          passenger_passport_expiry_day: '',
          passenger_passport_expiry_month: '',
          passenger_passport_expiry_year: '',
          date_of_birth: '',
          dobError: '',
          passport_expiry_date: '',
          pdoeError: '',
          pan_card: '',
          panError: '',
          passenger_nationality: '92'
        }
        ch[i] = obj
        setChild(ch)
      })
    } else {
      setChild(null)
    }
  }, [])

  return (
        <>
             <Box className="hotelrow">
                {/* <Box className="tltboxhotel">Guest Details</Box> */}
                  <Box className="p-3"><h5 className="">Guest Details</h5></Box>
                  <Box className="formboxguest">
                       <Row>
                            <Col xs={12} sm={12} className="mb-3">
                              <Box className="tltboxguestitem">
                                  <Box className="tltguestfrm">Name</Box>

                                  <Box className="dflx-box">
                                      <FormControl variant="outlined" size="small" className="guesttlt" >
                                          <Select
                                          native
                                          // value={ad.name_title}
                                          // onChange={(e) => {
                                          //   const ads = [...adult]
                                          //   ads[i].name_title = e.target.value.split('-')[0]
                                          //   ads[i].gender = e.target.value.split('-')[1]

                                          //   setAdult(ads)
                                          // }}
                                          >
                                            <option value="miss">Miss</option>
                                            <option value="mr">Mr</option>
                                            <option value="mrs">Mrs</option>
                                          </Select>
                                      </FormControl>
                                      <TextField className="guestinputtxt" size="small" variant="outlined" placeholder="First Name"
                                        // value={ad.first_name}
                                        // onChange={(e) => {
                                        //   const ads = [...adult]
                                        //   ads[i].first_name = e.target.value
                                        //   ads[i].fError = ''
                                        //   if (i === 0) {
                                        //     ads[i].lead_passenger = '1'
                                        //   }
                                        //   setAdult(ads)
                                        // }}
                                        // error={!!ad.fError}
                                        // helperText={ad.fError}

                                      />
                                      <TextField className="guestinputtxt" size="small" variant="outlined" placeholder="Last Name"
                                        // value={ad.last_name}
                                        // onChange={(e) => {
                                        //   const ads = [...adult]
                                        //   ads[i].last_name = e.target.value
                                        //   ads[i].lError = ''
                                        //   setAdult(ads)
                                        // }}
                                        // error={!!ad.lError}
                                        // helperText={ad.lError}
                                      />
                                  </Box>

                              </Box>
                            </Col>

                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                <Box className="tltboxguestitem">
                                    <Box className="tltguestfrm">Email Address</Box>
                                    <Box className="dflx-box">
                                        <TextField
                                         className="guestinputtxt mrinput"
                                         size="small"
                                         variant="outlined"
                                         placeholder="example@gmail.com"
                                         value={details.billing_email}
                                         onChange={(e) => {
                                           setDetails({
                                             ...details,
                                             billing_email: e.target.value,
                                             emailError: ''
                                           })
                                         }}
                                         error={!!details.emailError}
                                         helperText={details.emailError}
                                         />
                                    </Box>
                                    <p className='text-xs'>(Booking voucher will be sent to this email ID)</p>

                                </Box>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                <Box className="tltmobileboxguestitem">
                                    <Box className="tltguestfrm">Mobile Number</Box>
                                    <Box className="dflx-box">
                                        <FormControl variant="outlined" size="small" className="guestcountry" >
                                            <Select
                                                className=''
                                                native
                                                value={details.country_code}
                                                onChange={(e) => {
                                                  setDetails({
                                                    ...details,
                                                    country_code: e.target.value,
                                                    cError: ''
                                                  })
                                                }}
                                                error={!!details.cError}
                                                helperText={details.cError}
                                                >
                                                {countrylist.sort(sortPhoneNumber).map(option => (
                                                    <option value={option.country_code}>{option.country_code}</option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                        className="guestinputtxt"
                                        size="small"
                                        variant="outlined"
                                        placeholder="9999999999"
                                        value={details.passenger_contact}
                                        onChange={(e) => {
                                          setDetails({
                                            ...details,
                                            passenger_contact: e.target.value,
                                            phError: ''
                                          })
                                        }}
                                         error={!!details.phError}
                                         helperText={details.phError}
                                        />
                                    </Box>
                                </Box>
                            </Col>
                            
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Box className="submitsect-reviewguest">
                                    <Button variant="contained" color="success" onClick={handleClickOpen}>Submit Your Enquiry</Button>
                                </Box>
                            </Col>
                       </Row>

                       <div>
                        <Dialog
                          className='success-dialog'
                          open={open}
                          TransitionComponent={Transition}
                          keepMounted
                          onClose={handleClose}
                          aria-describedby="alert-dialog-slide-description"
                        >
                          <div class="card">
                            <div className='card-body'>
                              <div class="success alert">
                                <div class="alert-body">
                                  {/* Success ! */}
                                </div>
                              </div>
                            </div>
                            <h1>Success</h1> 
                            <p>We have your received your enquiry.<br/> we'll be in touch shortly!</p>
                          </div>
                        </Dialog>
                      </div>
                </Box>
            </Box>

        </>
  )
}

export default GuestDetails